import vince from "../images/members/vince.jpg"
import rowan from "../images/members/rowan.jpg"
import syd from "../images/members/syd.jpg"
import lane from "../images/members/lane.jpg"

export const members = [
    {
        name: "Lane",
        instrument: "Drums",
        img: lane,
        bio: {
            bio: [
                "Born the son of a dragon and a bardic sprite, Lane was raised in the heart the world’s largest volcano by evil fire demons. At a young age he learned to harness the fire within by following the rhythm of his surroundings. The inner chambers of the volcano would eb and flow to the beat of his mighty drumming. Until one day the molten rock below cracked under the pressure and intensity of his heated back beats and paradiddlings, releasing an eruption of magma, ash, and pure, unfiltered rock and roll. This of course unleashed the fire demons that resided in the volcano, kept at bay only by the beating of Lanes drums. He knew he'd have to track them down, but it was a small price to pay for unearthing an egress in the cave tunnels. Wreathed in flame, standing atop the pulverized rock that was his drum set, Lane set out on finding a new mantle. Freed from the underground catacombs he called his home, he grabbed a pair of Vic Firths, some Zildjians, and a bomb ass snare drum. Finally, the Inferno lord sat atop his throne, one with custom backing support, and set the world ablaze with raucous drumming."
            ],
            turnOns: [
                "Late night N64 sessions", 
                "Brunettes", 
                "Biking"
            ],
            turnOffs: [
                "Ignorance", 
                "Ham sandwiches",
                "The spotlight"
            ]
        }
    },
    {
        name: "Rowan",
        instrument: "Vocals",
        img: rowan,
        bio: {
            bio: [
            "Our tale begins with a routine sky diving lesson gone wrong. ",
            "Rowan had performed many sky dives over the years, but that fateful day in which her ",
            "parachute didn’t open was the same day she learned she no longer would sky dive; she would ",
            "sky live. As she tumbled through the air, seconds away from making contact with a group of ",
            "power lines, Rowan took in a deep breath and blasted forth a three-part harmony all on her own. ",
            "The strength emitting from her vocal cords was enough not only to keep her aloft, but carry her ",
            "up high into the sky. This is where she came upon the Cloud Folk of Arendell. They welcomed her ",
            "into their kingdom and trained her in the ways of their people, tracing her lineage back to an ",
            "ancient bloodline that used to defend the skies. Rowan’s vocal prowess grew in range and decibel ",
            "to a point where she could control the winds around her, giving her the power of flight and sonic ",
            "abilities to defend the Cloud Folk from the barbarian garrisons of the Evil Sky Castle. Once she ",
            "mastered her abilities she traveled far and wide to find other gifted adventurers to aid her in ",
            "her quest to protect the skies and her cloud domain. Now she is now known as the Sky Maven. ",
            ],
            turnOns: [
                "Onsies",
                "Jepson’s Malort",
                "Geralt of Rivia"
            ],
            turnOffs: [
                "Rude people", 
                "Sleeping", 
                "Peanut Butter"
            ]
        },
    },
    {
        name: "Syd / Andrew",
        instrument: "Guitar",
        img: syd,
        bio: {
            bio: [
                'The story of the Sea Man begins with a guitar riff played to the ocean so beautifully, the ocean itself sang back. Andrew learned guitar as a teenager to try and pick up girls and gain the dexterity and prowess of the Great Old Ones that came before him. Frusciante, Mayer, other really good guitar players whose first name was John. While practicing his guitar along the shore, Andrew noticed the ocean itself ceased its tidal motion just to be close to the melodic sounds coming from his guitar. The fish would jump in rhythm with his song, the crustations along the beach would follow him up and down the shore, and the starfish just kind of sat there. Because that’s what starfish do. The creatures of the sea beckoned him to join them underwater. And to his surprise he was able to breath and swim alongside them, the sounds of his guitar amplified by the waves. This became his practice technique from that day forth. On one of his “afternoon guitarswim’s” the ocean rumbled, disturbed by the eruption of a nearby volcano. This unfortunately set free a sleeping Leviathan from deep within the earth’s crust. A primordial chaos monster that was imprisoned by the Gods for being too powerful was now set free to wrought its pure malice and terror on the world. Steadfast, Andrew played a song so beautiful that it soothed the rotten beast to its core, becoming docile enough from him to slay. Alas, Andrew was a kind man and allowed the great beast to live on the conditions of peace. This lasted only minutes before the Leviathan swam away. Now he travels the world to try and find that wretched creature. Some say if you stick your head underwater you can hear him say, “I’ll get you one day, you Leviathan son of a Bitch”.'
            ],
            turnOns : [
                "Swimming", 
                "Computer Coding", 
                "Upside Down Jazz Chords"
            ],
            turnOffs: [
                "Gluten", 
                "Liars",
                "That F’n Leviathan"
            ]
        }
    },
    {
        name: "Vince",
        instrument: "Bass",
        img: vince,
        bio: {
            bio: [
                "Vince wrote everyone elses bios... I'm sure you can fill in the rest about him..."
            ],
            turnOns :[
                "DnD",
                "E&J",
                "The spotlight"
            ],
            turnOffs: [
                "Not having a good time",
                '"Emo" music',
                "The Dutch"
            ]
        }
    },
]